import React from 'react';
import RandomCarousel from "./RandomCarousel";

export default function Home() {
    return (
        <div>
            <RandomCarousel />
            <div className="container mt-4">
                <div className="row">

                    <h3><span className='title'>Starking Insulation</span></h3>
                    <p className='roboto fs-5'>
                        Established in the year 2016 at Pune, Maharashtra, we <b>Starking Insulation</b> are a <b>Sole Proprietorship</b> based firm, engaged as the foremost <b>Manufacturer and Wholesaler of PU Foam Sheet, PU Foam, etc.</b> Our products are high in demand due to their premium quality and affordable prices. Furthermore, we ensure to timely deliver these products to our clients, through this we have gained a huge clients base in the market.
                    </p>

                    <h3><span className='title'>Factsheet</span></h3>
                        <table className="table fs-5">
                            <tbody>
                                <tr>
                                    <td colSpan="2"><b>Basic Information</b></td>
                                </tr>
                            <tr>
                                <td>Nature of Business</td>
                                <td>Manufacturer</td>
                            </tr>
                            <tr>
                                <td>Additional Business</td>
                                <td>Service Provider</td>
                            </tr>
                            <tr>
                                <td>Company CEO</td>
                                <td>Ravindra Rupchand Kale</td>
                            </tr>
                            <tr>
                                <td>Total Number of Employees</td>
                                <td>11 to 25 People</td>
                            </tr>
                            <tr>
                                <td>GST Registration Date</td>
                                <td>01-07-2017</td>
                            </tr>
                            <tr>
                                <td>Legal Status of Firm</td>
                                <td>Proprietorship</td>
                            </tr>
                            <tr>
                                <td>Annual Turnover</td>
                                <td>2.5 to 3 CR</td>
                            </tr>                        <tr>
                                <td>GST Partner Name</td>
                                <td>Ravindra Rupchand Kale</td>
                            </tr>
                            <tr>
                                <td colSpan="2"><b>Statutory Profile</b></td>
                            </tr>
                            <tr>
                                <td>Import Export Code (IEC)</td>
                                <td>AYDPK6561H</td>
                            </tr>
                            <tr>
                                <td>Banker</td>
                                <td>SARASWAT BANK<br/>SARASWAT BANK</td>
                            </tr>
                            <tr>
                                <td>GST No.</td>
                                <td>27AYDPK6561H1Z9</td>
                            </tr>
                            <tr>
                                <td colSpan="2"><b>Packaging/Payment and Shipment Details</b></td>
                            </tr>
                            <tr>
                                <td>Payment Mode</td>
                                <td>Cash/Cheque/DD/Online</td>
                            </tr>
                            <tr>
                                <td>Shipment Mode</td>
                                <td>By Road</td>
                            </tr>
                            </tbody>
                        </table>

                    <h3><span className='title'>Why Us?</span></h3>
                    <p className='roboto fs-5'>
                        By providing a quality product and having experienced knowledge of the market, we have been able to attain a huge client base.
                    </p>
                    <p className='roboto fs-5'>
                        <b>Factors responsible for our enormous success are as follows:</b>
                    </p>
                    <ul className='fs-4'>
                        <li>In-depth industry knowledge</li>
                        <li>Timely completion of orders</li>
                        <li>Transparent business dealings</li>
                        <li>A qualified and trained team of professionals</li>
                        <li>Market leading prices</li>
                    </ul>

                    <h3><span className='title'>Experience</span></h3>
                    <p className='roboto fs-5'>
                        With 20 years of hands-on experience, Mr. Ravindra Rupchand Kale has led Starking Insulation to successfully complete numerous industrial and commercial projects. Our portfolio includes work for manufacturing plants, chemical industries, power stations, and commercial complexes. We have consistently delivered projects on schedule while maintaining the highest standards of workmanship. The experience gained across varied industries has strengthened our ability to handle projects of any scale and complexity. Our reputation is built on trust, reliability, and technical expertise, making us a preferred partner for insulation needs across the region.
                    </p>

                </div>
            </div>
        </div>
        
    );
}
